import { addMessages } from '@hana/i18n';

// Khoá chuỗi ipad.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'ipad.1': "Chuyển hạch toán sang HĐ mới",
  'ipad.2': "Giữ cả hai",
});
addMessages('en', {
  'ipad.1': "Move accounting to new invoice",
  'ipad.2': "Keep both",
});
